import { render, staticRenderFns } from "./withdrawal_confirmation_modal.vue?vue&type=template&id=3704b643&"
import script from "./withdrawal_confirmation_modal.vue?vue&type=script&lang=js&"
export * from "./withdrawal_confirmation_modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports